module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/airstrike.7d34046a.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/airstrike.png
// module id = 3730
// module chunks = 11